import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';

const BookingOverviewDates = ({arrivalDate, departureDate}) => (
  <ul className="spread-list">
    <li>
      <div>
        <Translate content="From" />
      </div>
      <div>
        {arrivalDate}
      </div>
    </li>

    <li>
      <div>
        <Translate content="To" />
      </div>
      <div>
        {departureDate}
      </div>
    </li>
  </ul>
);

BookingOverviewDates.PropTypes = {
  arrivalDate:PropTypes.string.isRequired,
  departureDate:PropTypes.string.isRequired,
};

export default BookingOverviewDates;
